import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "list-data" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "list-actions" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "empty"
}
const _hoisted_8 = { class: "actions" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import {
  slugList,
  slugCreate,
  slugPatch,
  slugDel,
} from "@/common/api/rest/game/slug";

import type { SlugType } from "@/common/types/slug";

import FormSlug from "@/components/forms/form-slug.vue";
import { baseConfirm, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'list-game-slug',
  props: {
    ownerId: {},
    type: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const selected = ref<SlugType | null>(null);
const list = ref<SlugType[]>([]);

const showModalAdd = ref(false);
const showModalDel = ref(false);

const disableIsMain = computed(
  () => list.value.filter((item) => item.is_main).length,
);

function fetchData() {
  if (!props.ownerId) return;

  slugList(props.ownerId)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        list.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addItem() {
  showModalAdd.value = true;
}

function addItemCancel() {
  showModalAdd.value = false;
}

function addItemConfirm() {
  slugCreate(props.ownerId, {
    is_main: 0,
    language: null,
    slug: null,
    type: props.type,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        addItemCancel();
        fetchData();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function delItem(data: SlugType) {
  showModalDel.value = true;
  selected.value = data;
}

function delItemCancel() {
  showModalDel.value = false;
  selected.value = null;
}

function delItemConfirm() {
  slugDel(selected.value?.slug_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        delItemCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patchItem(slug_id: string, payload: Partial<SlugType>) {
  slugPatch(slug_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (!success) {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeIsMain(slug_id: string, payload: Partial<SlugType>) {
  slugPatch(slug_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("slug.labels.slugs")), 1)
    ]),
    _createElementVNode("section", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.slug_id
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-danger px-3 py-2",
              onClick: ($event: any) => (delItem(item))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "trash",
                size: "1.25rem"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.delete")), 1)
            ], 8, _hoisted_6)
          ]),
          _createVNode(FormSlug, {
            data: item,
            "owner-id": props.ownerId,
            type: props.type,
            "is-patch": true,
            "disable-is-main": disableIsMain.value && !item.is_main,
            "onUpdate:data": ($event: any) => (patchItem(item.slug_id, $event)),
            "onUpdate:isMain": ($event: any) => (changeIsMain(item.slug_id, $event))
          }, null, 8, ["data", "owner-id", "type", "disable-is-main", "onUpdate:data", "onUpdate:isMain"]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "separator" }, null, -1))
        ], 64))
      }), 128)),
      ((list.value || []).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)("slug.texts.empty")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-md btn-default uppercase px-4",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addItem()))
        }, _toDisplayString(_unref(t)("slug.labels.add_slug")), 1)
      ])
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showModalAdd.value,
      title: _unref(t)('slug.labels.add_slug').toUpperCase(),
      message: _unref(t)('slug.texts.add_slug'),
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (addItemCancel())),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (addItemConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('slug.labels.delete_slug').toUpperCase(),
      message: _unref(t)('slug.texts.delete_slug'),
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (delItemCancel())),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (delItemConfirm()))
    }, null, 8, ["show", "title", "message"])
  ]))
}
}

})